import { useMemo } from 'react';
import { TDefaultAvatarProps } from '../appointments/doctor-filter';

function getTextClassname(version: TDefaultAvatarProps['version']) {
    if (version === 'small') {
        return 'Caption2Bold dr-text-darwin-green-primary';
    } else {
        return 'Title3Bold dr-text-darwin-green-primary';
    }
}

function getWrapperClassname(version: TDefaultAvatarProps['version']) {
    if (version === 'small') {
        return 'dr-w-24 dr-h-24 dr-rounded-circle dr-flex dr-items-center dr-justify-center dr-bg-darwin-green-bg-dark';
    } else {
        return 'dr-w-48 dr-h-48 dr-rounded-circle dr-flex dr-items-center dr-justify-center dr-bg-darwin-green-bg-dark';
    }
}

export function DefaultAvatar({ name, version = 'small' }: TDefaultAvatarProps): JSX.Element {
    const wordsToShowOnNameChip = useMemo(() => {
        const nameSplits = name?.split(' ') || [];
        const stringToDisplay = nameSplits.reduce((prev, acc) => {
            if (prev.length < 2 && !!acc.trim()) {
                return `${prev}${acc[0]}`;
            }

            return prev;
        }, '');

        return stringToDisplay.toUpperCase();
    }, [name]);

    const textClassName = getTextClassname(version);
    const wrapperClassname = getWrapperClassname(version);

    return (
        <div className={wrapperClassname}>
            <p className={textClassName}>{wordsToShowOnNameChip}</p>
        </div>
    );
}
